import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'
import './SignUp.css'

const PhoneVerificationUI = ({ context, messageList, onSubmit, submitted, successMsg,
  errorList, setErrorList,
  // verification code
  verifCode, onVerifCodeChange, verifCodeError, setVerifCodeError
}) =>
  <React.Fragment>
    {
      <CardUI context={context}>
        <FormSF context={context} className='pub_signup' messageList={messageList} buttonMessageKey='c_verify'
          onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
          busy={submitted}>
          <InputTextSF name='verifCode' required={true} autoFocus={true}
            messageList={messageList} labelKey='c_verification_code'
            value={verifCode} onChange={onVerifCodeChange}
            error={verifCodeError} setError={setVerifCodeError}
          />
        </FormSF>
      </CardUI>
    }
  </React.Fragment>


export default PhoneVerificationUI
